
import { Options, Vue } from "vue-class-component"
import dragger, { config } from "@/index"
import "ant-design-vue/dist/antd.css"
@Options({
  name: "app",
  components: {
    "form-dragger": dragger
  }
})
export default class App extends Vue {
  config: any = config
}
